import React, { useEffect, useState, useRef } from "react";
import _ from "lodash";
import styled from "styled-components";
import LabelSelector from "../../molecules/LabelSelector";
import { ReactComponent as Arrow } from "./../../atoms/icons/arrow.svg";
import enhanceWithClickOutside from "react-click-outside";
import { getFLExcludes, getCMExcludes } from "../../organisms/MealSelectorContent/utils";

const Wrap = styled.div`
    width: calc(50% - 8px);
    margin-right: 16px;
`;

const Button = styled.button`
    position: relative;
    width: 100%;
    height: 32px;
    border-radius: 3px;
    border: solid 1px #e6e6e6;
    padding: 4px 40px 4px 12px;
    background: transparent;
    color: #5f645f;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    cursor: pointer;
    user-select: none;
    outline: none;
    box-shadow: none;

    &:focus,
    &:hover,
    &:active {
        outline: none;
        box-shadow: none;
    }

    span {
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
        overflow: hidden;
    }

    svg {
        position: absolute;
        top: 3px;
        right: 7px;
        background: #fff;
    }

    &.active svg {
        transform: rotate(180deg);
    }

    b.desktop-show {
        display: none;
    }

    @media (min-width: 990px) {
        font-size: 14px;
        b {
            display: none;
        }
        b.desktop-show {
            display: inline;
        }
    }
`;

const Inner = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin: 0 -4px;
    padding: 0 24px 16px 24px;
    z-index: 3;
    background: #fff;
    box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.08);

    @media (min-width: 1200px) {
        padding: 0 12px 16px 12px;
        max-width: 100%;
    }
`;

const InnerWrap = styled.div``;

const Paragraph = styled.p`
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    margin: 5px 4px 0;
    padding: 12px 0 0 0;
    font-size: 11px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: normal;
    text-align: center;
    color: #5f645f;
`;

function Exclusions(props) {
    const { selectedExclusions, exclusions, exclusionChange, main_title } = props;
    const [show, setShow] = useState(false);

    const node = useRef();

    useEffect(() => {
        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);

    const handleClick = e => {
        if (node.current.contains(e.target)) {
            return;
        }
        setShow(false);
    };

    const onClick = () => {
        setShow(!show);
    };

    const handleExclusionChange = (e, reference) => {
        exclusionChange(e, reference);
    };

    const exclusionString = _.join([...new Set(selectedExclusions)], ", ");
    const filterExclusions = () => {
        let _exclusions = exclusions;
        if (typeof main_title !== 'undefined') {
            let skuType;
            if (getFLExcludes(main_title)) {
                skuType = "FL-";
            } else if (getCMExcludes(main_title)) {
                skuType = "CM-";
            } else {
                skuType = "MD-";
            }
    
            _exclusions = _exclusions.filter(item => item.sku.includes(skuType));
        }
        return _exclusions;
    }

    const filteredExclusions = filterExclusions();

    return (
        <Wrap
            ref={node}
            className="inner-settings__item"
        >
            <Button
                onClick={onClick}
                className={show === true ? "active" : ""}
            >
                <span>
                    <b>Exclusions:</b>&nbsp;
                    <b className="desktop-show">Exclude Ingredients:</b>
                    &nbsp;
                    {exclusionString.length > 0 ? exclusionString : "None"}
                </span>
                <Arrow />
            </Button>
            {show ? (
                <Inner>
                    <InnerWrap>
                        {filteredExclusions.map((exclusion) => {
                            return (
                                <LabelSelector
                                    text={exclusion.name}
                                    key={exclusion.id}
                                    id={exclusion.id}
                                    exclusionChange={
                                        handleExclusionChange
                                    }
                                    selectedExclusions={selectedExclusions}
                                />
                            );
                        })}
                    </InnerWrap>
                    <Paragraph>
                        Every ModifyHealth meal is free of gluten, wheat,
                        refined sugars, artificial colors &#38; flavors
                    </Paragraph>
                </Inner>
            ) : null}
        </Wrap>
    );
}

export default enhanceWithClickOutside(Exclusions);
